export default "__VITE_ASSET__BKOcNyck__"